import React from "react";
import PropTypes from "prop-types";
import { ScaleLoader, FadeLoader } from "react-spinners";

const Loader = ({ color, size, height, width, margin, radius, variant }) => {
  return variant === "secondary" ? (
    <FadeLoader
      height={height}
      width={width}
      margin={margin}
      radius={2}
      color={color}
    />
  ) : (
    <ScaleLoader
      color={color}
      loading={true}
      size={size}
      height={height}
      width={width}
      radius={radius}
      margin={margin}
    />
  );
};

Loader.defaultProps = {
  color: "#102E88",
  height: 35,
  width: 4,
  radius: 2,
  margin: 2,
};

Loader.propTypes = {
  color: PropTypes.string,
  loading: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  radius: PropTypes.number,
  margin: PropTypes.number,
  size: PropTypes.number,
  variant: PropTypes.string,
};

export default Loader;
